import React, {Component} from 'react'
import Base from '../BaseComponent'

class Icon extends Component {

  render () {

    return (
      <Base modifiers={[this.props.type]} family="Icon" >
        { this.props.children }
      </Base>
    )
  }
}

export default Icon



// WEBPACK FOOTER //
// ./src/js/components/Icon/Icon.jsx